/* eslint no-console: 0 */
import ToolsAPI from "../../api/assistantTools";
import types from "../mutation-types";
import { throwErrorMessage } from "../utils/api";

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isFetchingItem: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getUIFlags: (stateParam) => stateParam.uiFlags,
  getTools: (stateParam) => stateParam.records,
  getTool: (stateParam) => (id) =>
    stateParam.records.find((record) => record.id === id),
};

export const actions = {
  get: async ({ commit }) => {
    commit(types.SET_ASSISTANT_TOOLS_UI_FLAG, { isFetching: true });
    try {
      const response = await ToolsAPI.get();
      commit(types.SET_ASSISTANT_TOOLS, response.data);
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_ASSISTANT_TOOLS_UI_FLAG, { isFetching: false });
    }
  },

  show: async ({ commit }, { id }) => {
    commit(types.SET_ASSISTANT_TOOLS_UI_FLAG, { isFetchingItem: true });
    try {
      const response = await ToolsAPI.show(id);
      commit(types.SET_ASSISTANT_TOOL_ITEM, response.data);
      return response.data;
    } catch (error) {
      throwErrorMessage(error);
      return null;
    } finally {
      commit(types.SET_ASSISTANT_TOOLS_UI_FLAG, { isFetchingItem: false });
    }
  },

  create: async ({ commit }, toolData) => {
    commit(types.SET_ASSISTANT_TOOLS_UI_FLAG, { isCreating: true });
    try {
      const response = await ToolsAPI.create(toolData);
      commit(types.ADD_ASSISTANT_TOOL, response.data);
      return response.data;
    } catch (error) {
      throwErrorMessage(error);
      throw error;
    } finally {
      commit(types.SET_ASSISTANT_TOOLS_UI_FLAG, { isCreating: false });
    }
  },

  update: async ({ commit }, { id, ...updateData }) => {
    commit(types.SET_ASSISTANT_TOOLS_UI_FLAG, { isUpdating: true });
    try {
      const response = await ToolsAPI.update(id, updateData);
      commit(types.EDIT_ASSISTANT_TOOL, response.data);
      return response.data;
    } catch (error) {
      throwErrorMessage(error);
      throw error;
    } finally {
      commit(types.SET_ASSISTANT_TOOLS_UI_FLAG, { isUpdating: false });
    }
  },

  delete: async ({ commit }, id) => {
    commit(types.SET_ASSISTANT_TOOLS_UI_FLAG, { isDeleting: true });
    try {
      await ToolsAPI.delete(id);
      commit(types.DELETE_ASSISTANT_TOOL, id);
    } catch (error) {
      throwErrorMessage(error);
      throw error;
    } finally {
      commit(types.SET_ASSISTANT_TOOLS_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_ASSISTANT_TOOLS_UI_FLAG]: (stateParam, flag) => {
    stateParam.uiFlags = { ...stateParam.uiFlags, ...flag };
  },

  [types.SET_ASSISTANT_TOOLS]: (stateParam, data) => {
    stateParam.records = data;
  },

  [types.SET_ASSISTANT_TOOL_ITEM]: (stateParam, data) => {
    stateParam.records.push(data);
  },

  [types.ADD_ASSISTANT_TOOL]: (stateParam, data) => {
    stateParam.records.push(data);
  },

  [types.EDIT_ASSISTANT_TOOL]: (stateParam, data) => {
    const index = stateParam.records.findIndex(
      (record) => record.id === data.id,
    );
    if (index !== -1) {
      stateParam.records[index] = data;
    }
  },

  [types.DELETE_ASSISTANT_TOOL]: (stateParam, id) => {
    const index = stateParam.records.findIndex((record) => record.id === id);
    if (index !== -1) {
      stateParam.records.splice(index, 1);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
